// extracted by mini-css-extract-plugin
module.exports = {"container":"Burger-module--container--29Z8V","lineContainer":"Burger-module--lineContainer--3WumV","active":"Burger-module--active--1TEU6","line":"Burger-module--line--ryX_e"};